import * as e from "react";
import { Fragment as t, jsxs as n } from "react/jsx-runtime";
var r = {
	title: "_title_9hxhg_1",
	"small-header-on-mobile": "_small-header-on-mobile_9hxhg_13",
	"no-padding": "_no-padding_9hxhg_62"
}, i = /* @__PURE__ */ function(e) {
	return e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.SPAN = "span", e;
}({}), a = ({ after: i = null, before: a = null, className: o = "", gtmEventLabel: s = null, noPadding: c = !1, regressionTag: l = null, smallHeaderOnMobile: u = !1, tag: d = "h2", testId: f = null, title: p, ...m }) => p ? /* @__PURE__ */ n(t, { children: [
	a,
	e.createElement(d, {
		"data-testid": f,
		"data-gtm-event-label": s,
		"data-regression-tag": l,
		className: [
			r.title,
			o || "",
			c ? r.noPadding : "",
			u ? r.smallHeaderOnMobile : ""
		].join(" "),
		...m
	}, p),
	i
] }) : null;
//#endregion
export { i as Header, a as default };
